import(/* webpackMode: "eager" */ "/app/apps/ashtrom-drachim/app/[locale]/not-found.tsx");
